import React, {useEffect, useState} from 'react'
import styled from "styled-components";

const InputNumberSelector = ({onChange, number, min = 0}) => {
    const decrease = () => {
        if (number - 1 < min)
            onChange(min);
        else
            onChange (number - 1);
    }

    const increase = () => {
        onChange (number + 1);
    }

    return (
        <div className="d-flex justify-content-center">
            <Circle onClick={() => decrease()}>-</Circle>
            <Content>{number}</Content>
            <Circle onClick={() => increase()}>+</Circle>
        </div>
    )
}

const Content = styled.div`
    width: 28px;
    text-align: center;
    user-select: none;
`;

const Circle = styled.div`
    width: 20px;
    height: 20px;
    border: 2px solid hsl(0, 0%, 50%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    user-select: none;
    
    margin-top: 2px;

    &:hover {
        background-color: hsl(0, 0%, 50%);
        color: white;
        border-color: gray;
    }
`;

export default InputNumberSelector;